import { colors } from '../../config/theme'

export default {
  generalError: {
    height: 20,
    textAlign: 'center',
    textTransform: 'capitalize',
    color: colors.error
  },
  formBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 25
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/style.js